import { FormFieldModel, FormFieldValidator, TranslationService } from '@alfresco/adf-core';
import { inject } from '@angular/core';

export class EbenUploadValidator implements FormFieldValidator {

  private readonly translationService = inject(TranslationService);

  isSupported(field: FormFieldModel): boolean {
    return field.type === 'upload';
  }

  validate(field: FormFieldModel): boolean {
    if (this.isSupported(field)) {
      if(field.params.error) {
        const error: {relatedContent, error, invalidPlaceholders: string[], invalidDmsPlaceholders: string[]} = field.params.error;

        field.validationSummary.message = error.error;

        field.validationSummary.attributes = new Map<string, string>();
        field.validationSummary.attributes.set('fieldname', field.name);

        if(error.error === 'DOCUMENT.ERROR.INVALID_PLACEHOLDERS') {
          if(error.invalidDmsPlaceholders && error.invalidDmsPlaceholders.length > 0) {
            const invalidDmsPlaceholderError: string = this.translationService.instant('DOCUMENT.ERROR.INVALID_DMS_PLACEHOLDERS',  {'invalidDmsPlaceholders': error.invalidDmsPlaceholders.join(', ')});
            field.validationSummary.attributes.set('invalidDmsPlaceholderError', invalidDmsPlaceholderError + '; ');
          } else {
            field.validationSummary.attributes.set('invalidDmsPlaceholderError', '');
          }

          if(error.invalidPlaceholders && error.invalidPlaceholders.length > 0) {
            const invalidPlaceholderError: string = this.translationService.instant('DOCUMENT.ERROR.INVALID_ANY_PLACEHOLDERS',  {'invalidPlaceholders': error.invalidPlaceholders.join(', ')});
            field.validationSummary.attributes.set('invalidPlaceholderError', invalidPlaceholderError + '; ');
          } else {
            field.validationSummary.attributes.set('invalidPlaceholderError', '');
          }
        }
        return false;
      }
    }
    return true;
  }
}
